import { useEffect, useState } from "react";

import { Toaster } from "~/components/Toaster";
import { UpdateModal } from "~/components/UpdateModal";
import { api } from "~/utils/api";

import { DevelopmentTab } from "./components/DevelopmentTab";
import { PersonalTrainerExercisesGetter } from "./components/PersonalTrainerExercisesGetter";
import { initiateSession } from "./modules/authentication/services";
import { AppRouter } from "./routes";
import { app_version } from "./utils/version";

import "swiper/css";
import "swiper/css/scrollbar";

initiateSession();

type AppVersionEntry = {
	version: string;
	releaseNotes: string[];
	releasedAt: string;
};

function App() {
	const [latestVersion, setLatestVersion] = useState<AppVersionEntry | null>(
		null,
	);

	useEffect(() => {
		api
			.get<AppVersionEntry>("/version")
			.then((res) => setLatestVersion(res.data))
			.catch(() => undefined);
	}, []);

	return (
		<>
			<DevelopmentTab />
			<AppRouter />
			<Toaster />
			<PersonalTrainerExercisesGetter />
			{latestVersion && (
				<UpdateModal
					latestVersion={latestVersion.version}
					releaseNotes={latestVersion.releaseNotes}
					releasedAt={latestVersion.releasedAt}
				/>
			)}
			<span className="hidden">versão {app_version}</span>
		</>
	);
}

export default App;
